import { createAsyncThunk } from "@reduxjs/toolkit";
import allAPI from "../../api/api";

export const getServiceCommunicationData = createAsyncThunk(
  "communication/config/list",
  async (payload) => {
    try {
      const response = await allAPI.CommunicationService.findAll(payload);
      if (response.status === 200) {
        return response.data.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);

export const deleteServiceCommunicationThunk = createAsyncThunk(
  "communication/config/delete",
  async (payload) => {
    try {
      const response = await allAPI.CommunicationService.remove(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);

export const createServiceCommunicationThunk = createAsyncThunk(
  "communication/config",
  async (payload) => {
    try {
      const response = await allAPI.CommunicationService.create(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);

export const updateServiceCommunicationThunk = createAsyncThunk(
  "communication/config/update",
  async (payload) => {
    try {
      const response = await allAPI.CommunicationService.update(
        payload.id,
        payload,
      );
      console.log("update response slice", response);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);
